import React, { useEffect, useState } from "react";
import { waLink, BRAND } from "../../lib/mockData";

export default function FloatingWhatsApp() {
  const [tipOpen, setTipOpen] = useState(false);
  const [hasSeen, setHasSeen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!hasSeen) {
        setTipOpen(true);
        setHasSeen(true);
        setTimeout(() => setTipOpen(false), 5000);
      }
    }, 2500);
    return () => clearTimeout(t);
  }, [hasSeen]);

  return (
    <div
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex items-end gap-3"
      data-testid="floating-whatsapp"
    >
      {/* Tooltip / message bubble */}
      <div
        className={`hidden sm:flex flex-col bg-cream border border-gold/40 shadow-xl rounded-2xl rounded-br-sm px-4 py-3 max-w-[240px] transition-all duration-300 origin-bottom-right ${
          tipOpen ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-2 scale-95 pointer-events-none"
        }`}
      >
        <div className="text-[11px] uppercase tracking-widest text-gold font-semibold">
          {BRAND.name}
        </div>
        <div className="text-sm text-emerald mt-0.5 leading-tight">
          Need help choosing a hamper? <span className="italic text-gold">Chat with us!</span>
        </div>
        <button
          onClick={() => setTipOpen(false)}
          className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-emerald text-cream text-[10px] shadow-md hover:bg-emerald-dark"
          aria-label="close"
        >
          ✕
        </button>
      </div>

      {/* WhatsApp FAB */}
      <a
        href={waLink(`Hi ${BRAND.name}, I'd like to enquire about your hampers.`)}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setTipOpen(true)}
        onMouseLeave={() => setTipOpen(false)}
        className="relative group w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.7)] hover:scale-105 active:scale-95 transition-transform"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-btn"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true" className="relative">
          <path d="M17.5 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1s-.8.9-1 1.1c-.2.2-.4.2-.6.1-.3-.1-1.2-.4-2.4-1.5-.9-.8-1.5-1.8-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.6-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1 1-1 2.4 1 2.9 1.2 3.1c.1.2 2 3 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.5-.3zM12 2C6.5 2 2 6.5 2 12c0 1.9.5 3.6 1.4 5.2L2 22l4.9-1.3c1.5.8 3.2 1.3 5.1 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2z" />
        </svg>
      </a>
    </div>
  );
}
